<script setup lang="ts">
// Plan 2026-10-04 Task 3: JH top strip, moved out of BgaJhSignalTab.vue's
// isJh branch. JH's % label uses the signal-synth return (FVA-corrected)
// with a fallback to the jhNav poll, matching today's BgaJhSignalTab logic.
import SparklineBar from '../SparklineBar.vue'
import type { SignalTabCtx } from '../nav/fundPages'

defineProps<{ ctx: SignalTabCtx }>()
</script>

<template>
  <SparklineBar
    :fund-return-pct="ctx.activeFundReturnPct ?? ctx.jhReturnPct"
    fund-label="JH"
    :fund-spark-values="ctx.jhSparkValues"
    :nas-return-pct="ctx.nasReturnPct"
    :vix="ctx.intSignal?.vix ?? null"
    :gbpusd-return-pct="ctx.gbpusdReturn" />
</template>
